import { render, staticRenderFns } from "./DialogManager.vue?vue&type=template&id=28f0bf85&scoped=true"
import script from "./DialogManager.vue?vue&type=script&lang=js"
export * from "./DialogManager.vue?vue&type=script&lang=js"
import style0 from "./DialogManager.vue?vue&type=style&index=0&id=28f0bf85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0bf85",
  null
  
)

export default component.exports